export default __webpack_public_path__ + "static/media/cash.2a3fd5ad.webp";